<template>
  <div id="international">
    <div class="header-nav">
      <a class="tab-item" :class="{'active': v.colId == colId}" v-for="(v, i) in menu_list" :key="v.cnName" @click="tabHandle(v,i)">
          <span>{{v.cnName}}</span>
      </a>
    </div>
    <div class="nav-wrap">
      <div class="nav-title">
        <span v-show="v.colId == colId" v-for="(v, i) in menu_list" :key="i">{{v.cnName}}</span>
      </div>
    </div>
    <div id="international_home">
      <project-list ref="porlist" :colid="colId"></project-list>
    </div>
  </div>
</template>

<script>
import ProjectList from "@/components/ProjectList";
import { getColumns } from "@/api/home";

export default {
  components: {
    ProjectList,
  },
  data() {
    return {
      banner: {
        imgUrl: "",
      },
      colId: "",
      tab_list: [],
      project_list: [],
      menu_list: []
    };
  },
  mounted() {
    this.$store.commit("setCurrentMenuI", 3);
    getColumns(this.$route.params.cid).then((res) => {
      if (res) {
        this.menu_list = res[0].subList
        if (!this.$route.params.aid) {
          if (res[0].subList.length > 0) {
            this.colId = res[0].subList[0].colId;
            this.$router.replace(`/international/${this.$route.params.cid}/${this.colId}`)
            this.$refs.porlist.loadData(this.colId);
          }
        } else {
          this.colId = this.$route.params.aid
          this.$refs.porlist.loadData(this.colId);
        }
      }
    });
  },
  methods: {
    tabHandle(pData) {
      this.$router.push(`/international/${this.$route.params.cid}/${pData.colId}`)
      this.colId = pData.colId
      this.$refs.porlist.loadData(this.colId);
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px) {
  #international_home {
    //padding: 0 rem(225) rem(100) rem(225);
    padding: 0 rem(75) rem(100) rem(75);
  }

  .home-title {
    display: none;
  }
  .nav-wrap {
    padding: 0 rem(135) 0 rem(75);
  }
}
@media only screen and (max-width: 768px) {
  #international_home {
    padding: 0 0.575rem rem(100) 0.575rem;
  }
}
</style>
